export default "__VITE_ASSET__DxkliJ_H__"